import { render, staticRenderFns } from "./SectionReferences.vue?vue&type=template&id=d4d2674a&"
import script from "./SectionReferences.vue?vue&type=script&lang=js&"
export * from "./SectionReferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports